import { MemberContactRankingType } from '../enums';

export class ContactInfoRank {
  id = 0;

  memberId = 0;

  careTeamMemberId = 0;

  type: MemberContactRankingType;

  ranking = 0;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.type = MemberContactRankingType.byKey[obj.type];
  }
}

export default ContactInfoRank;
